export const APP_NAME_SPACE = 'JP_VOICE_SAVER';
export const VERSION = '0.0.0';
export const DEFAULT_TAG_COLOR = '#000000ff';
export const DEFAULT_COLOR_1 = '#280b0bff';
export const DEFAULT_COLOR_2 = '#ffffffff';
export const BACKGROUND_COLOR = '#f9f9f9ff';